import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next';

export const mutateChangelogVideoUpload = () => {
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationKey: ['changelog-video-upload'],
        mutationFn: async ({ file, width, height }) => {
            const formData = new FormData();

            formData.append('video', file);

            if (width && height) {
                formData.append('width', width);
                formData.append('height', height);
            }

            const { data } = await axios.post(route('studio.v1.api.changelog.video.store'), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return data;
        },
        onError: async ({ response }) => {
            notifications.show({
                color: 'red',
                title: t('common.error'),
                // A file over the server's post limit never reaches validation,
                // so the response can be empty — say something either way.
                message: response?.data?.message || t('changelog.entry.videoUploadFailed'),
            })
        }
    });

    return mutation;
}
